import { ProductGroupActionTypes } from '../../../enums/ActionEnums';
export const productGroupActions = {
    init: () => ({
        type: ProductGroupActionTypes.INIT,
    }),
    getDeliveryPromise: (payload) => ({
        type: ProductGroupActionTypes.GET_DELIVERY_PROMISE,
        payload,
    }),
    setDeliveryPromise: (payload) => ({
        type: ProductGroupActionTypes.SET_DELIVERY_PROMISE,
        payload,
    }),
    setProductGroups: (payload) => ({
        type: ProductGroupActionTypes.SET_PRODUCT_GROUPS,
        payload,
    }),
};
